class KpProductComparison extends HTMLElement {
  connectedCallback() {
    if (this.dataset.kpComparisonReady === 'true') return;

    this.dataset.kpComparisonReady = 'true';
    this.range = this.querySelector('[data-kp-comparison-range]');

    if (this.range) {
      this.updatePosition = () => {
        this.style.setProperty('--kp-comparison-position', `${this.range.value}%`);
      };

      this.range.addEventListener('input', this.updatePosition);
      this.updatePosition();
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.2 }
      );
      this.observer.observe(this);
    } else {
      this.classList.add('is-visible');
    }
  }

  disconnectedCallback() {
    if (this.range && this.updatePosition) {
      this.range.removeEventListener('input', this.updatePosition);
    }
    this.observer?.disconnect();
    delete this.dataset.kpComparisonReady;
  }
}

if (!customElements.get('kp-product-comparison')) {
  customElements.define('kp-product-comparison', KpProductComparison);
}
